import axios from 'axios'

export default {
    getStrengths() {
        return axios.get('/strength/v1')
            .then(response => {
                return response.data
            })
    }
}